import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X } from 'lucide-react';

const NAV = {
  loom: [
    ['/app', 'Writer Studio'],
    ['/loom', 'AI Novel Loom'],
    ['/loom/editor', 'Review Inbox'],
    ['/app/business', 'Business Center'],
    ['/notebook', 'Writer Notebook'],
    ['/bookstore', 'Bookstore'],
  ],
  admin: [
    ['/admin', 'Admin Hub'],
    ['/admin/admin', 'Admin'],
    ['/admin/finance', 'Finance'],
    ['/admin/users', 'Users'],
    ['/admin/operations', 'Operations'],
    ['/admin/marketing', 'Marketing & Media'],
    ['/admin/it', 'IT'],
    ['/admin/inbox', 'Support Inbox'],
    ['/admin/email-translator', 'Email Translator'],
    ['/admin/reader-languages', 'Reader Languages'],
  ],
};

export const WorkbenchDrawer = ({ open, onClose, surface }) => {
  const location = useLocation();
  if (!open) return null;

  return (
    <div className="absolute inset-0 z-50" data-testid="workbench-page-drawer">
      <button
        type="button"
        aria-label="Close page drawer"
        onClick={onClose}
        className="absolute inset-0 bg-black/35"
        data-testid="workbench-page-drawer-backdrop"
      />
      <aside className="relative h-full w-[min(82vw,19rem)] border-r border-border bg-card p-4 shadow-2xl">
        <div className="flex items-center justify-between border-b border-border pb-3">
          <div>
            <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">Workbench</div>
            <div className="text-base font-semibold" data-testid="workbench-page-drawer-title">Pages</div>
          </div>
          <button
            type="button"
            aria-label="Close page drawer"
            title="Close pages"
            onClick={onClose}
            className="flex h-9 w-9 items-center justify-center rounded-sm border border-border bg-background text-foreground"
            data-testid="workbench-page-drawer-close"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <nav className="mt-3 space-y-1" aria-label="Workbench pages">
          {NAV[surface].map(([to, label]) => {
            const active = location.pathname === to || (to !== '/admin' && to !== '/app' && location.pathname.startsWith(`${to}/`));
            return (
              <Link
                key={to}
                to={to}
                onClick={onClose}
                className={`block rounded-sm border px-3 py-2.5 text-sm font-medium transition-colors ${active ? 'border-primary bg-primary/10 text-primary' : 'border-transparent text-foreground hover:border-border hover:bg-secondary'}`}
                data-testid={`workbench-page-link-${to.replace(/^\//, '').replaceAll('/', '-') || 'home'}`}
              >
                {label}
              </Link>
            );
          })}
        </nav>
      </aside>
    </div>
  );
};